import React, { Component } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import "./navigation.css";
import { AddLink } from "../../../assets/images";
import axios from "../../../axios/axios";
import { message } from "antd";
import LoadingOverlay from "react-loading-overlay";
import { adminConfig } from "../../../utils/adminConfig";

export default class AddNavigation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,

      menuData: {
        domain: "",
        menu: "",
        sub_menu: [],
        url: "",
        successor: "",
        icon: "",
      },
      sub_menu_name: "",
      sub_menu_url: "",

      error: {},

      isAddSubMenu: false,

      tv_menu: [],
      tvi_menu: [],

      nested_sub_menu: [],
      nested_sub_menu_name: "",
      nested_sub_menu_url: "",

      isNestedSubMenu: false,
    };
  }

  componentDidMount = () => {
    this.getAllMenu();
  };

  getAllMenu = () => {
    this.setState({ isLoading: true });
    axios
      .get("/get-all-menu", adminConfig())
      .then((res) => {
        this.setState({ isLoading: false });

        let { tv_menu, tvi_menu } = res.data;

        this.setState({ tv_menu, tvi_menu });
      })
      .catch((err) => {
        this.setState({ isLoading: false });

        console.error(err);
        message.error("Something went wrong");
      });
  };

  handleOnChange = (e) => {
    let { name, value } = e.target;
    let { menuData, error } = this.state;

    if (name === "domain") {
      if (value) {
        error[name] = "";
      } else {
        error[name] = "This field required ❗";
      }
      menuData[name] = value;
      menuData.successor = "";
    } else {
      if (!menuData.domain) {
        error.domain = "This field required ❗";
      } else {
        error.domain = "";

        if (value) {
          error[name] = "";

          if (name === "url") {
            if (this.hasBlankSpace(value)) {
              error[name] = "Enter valid url";
            } else {
              error[name] = "";
            }
          }
        } else {
          error[name] = "This field required ❗";
        }

        menuData[name] = value;
      }
    }

    this.setState({ menuData, error });
  };

  handleOnchangeSubMenu = (e) => {
    let { name, value } = e.target;
    let { menuData, error } = this.state;

    if (!menuData.domain) {
      error.domain = "This field required ❗";
    } else {
      error.domain = "";

      if (value) {
        error[name] = "";

        if (name === "sub_menu_url" || name === "nested_sub_menu_url") {
          if (this.hasBlankSpace(value)) {
            error[name] = "Enter valid url";
          } else {
            error[name] = "";
          }
        }
      } else {
        error[name] = "This field required ❗";
      }

      this.setState({ [name]: value });
    }

    this.setState({ error });
  };

  addSubMenu = () => {
    let { sub_menu_name, sub_menu_url, menuData, error, nested_sub_menu } =
      this.state;

    if (!sub_menu_name) {
      error.sub_menu_name = "This field required";
      this.setState({ error });
      return;
    }

    if (nested_sub_menu.length > 0) {
      error.sub_menu_url = false;
      this.setState({ error });
    }

    if (!sub_menu_url && nested_sub_menu.length === 0) {
      error.sub_menu_url = "This field required";
      this.setState({ error });
      return;
    }

    if (error.sub_menu_name || error.sub_menu_url) return;

    error.sub_menu_name = false;
    error.sub_menu_url = false;

    this.setState({ error });

    let data = {
      sub_menu: sub_menu_name,
      sub_url: nested_sub_menu.length === 0 ? sub_menu_url : "",
      nested_sub_menu,
    };

    menuData.sub_menu.push(data);

    this.setState({
      menuData,

      sub_menu_name: "",
      sub_menu_url: "",

      isAddSubMenu: false,
      nested_sub_menu: [],
    });
  };

  handleImage = (e) => {
    let file = e.target.files[0];
    let validExtension = ["png"];

    let { menuData } = this.state;

    if (file) {
      let extension = this.getFileExtension(file);

      if (validExtension.includes(extension)) {
        menuData.icon = file;
        this.setState({ menuData });
      } else {
        message.error("The file format is not supported");
      }
    }
  };

  getFileExtension = (file) => {
    let regex = new RegExp("[^.]+$");
    return file.name.match(regex)[0].toLowerCase();
  };

  hasBlankSpace = (str) => /\s/.test(str);

  submitMenu = (e) => {
    e.preventDefault();

    let { menuData, tv_menu, tvi_menu } = this.state;

    if (!menuData.icon) {
      message.error("Please select menu icon");
      return;
    }

    if (menuData.sub_menu.length === 0) {
      // menuData.url = menuData.url.includes("/")
      //   ? menuData.url
      //   : "/" + menuData.url;
    } else {
      menuData.url = "";
    }

    if (!menuData.successor) {
      if (menuData.domain === "tv") {
        if (tv_menu.length > 0) {
          menuData.successor = tv_menu[tv_menu.length - 1]._id;
        }
      } else {
        if (tvi_menu.length > 0) {
          menuData.successor = tvi_menu[tvi_menu.length - 1]._id;
        }
      }
    }

    let formData = new FormData();

    formData.append("menu", menuData.menu);
    formData.append("logo", menuData.icon);

    menuData.sub_menu.forEach((dd, key) => {
      formData.append(`sub_menu[${key}]`, JSON.stringify(dd));
    });

    formData.append("url", menuData.url);
    formData.append("successor", menuData.successor);
    formData.append("domain", menuData.domain);

    this.setState({ isLoading: true });

    axios
      .post("/add-menu", formData, adminConfig())
      .then((res) => {
        if (res.data.status) {
          message.success(res.data.message);
          this.setState({
            menuData: {
              domain: "",
              menu: "",
              sub_menu: [],
              url: "",
              icon: "",
            },
          });
          this.getAllMenu();
        } else {
          this.setState({ isLoading: false });

          message.error(res.data.message);
        }
      })
      .catch((err) => {
        this.setState({ isLoading: false });

        console.error(err);
        message.error("Something went wrong");
      });
  };

  addNestedSubMenu = (e) => {
    e.preventDefault();

    let { nested_sub_menu_name, nested_sub_menu_url, error, nested_sub_menu } =
      this.state;

    if (error.nested_sub_menu_name || error.nested_sub_menu_url) return;

    nested_sub_menu.push({
      nested_sub_menu_name,
      nested_sub_menu_url,
    });

    this.setState({
      nested_sub_menu,
      nested_sub_menu_name: "",
      nested_sub_menu_url: "",

      isNestedSubMenu: false,
    });
  };

  render() {
    let {
      menuData,
      error,
      tv_menu,
      tvi_menu,
      isNestedSubMenu,
      nested_sub_menu,
    } = this.state;

    return (
      <LoadingOverlay spinner active={this.state.isLoading} text="Loading...">
        {/* NESTED SUB MENU */}

        <Modal show={isNestedSubMenu} backdrop="static" keyboard={false}>
          <Modal.Header>
            <Modal.Title>Nested Sub Menu</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={this.addNestedSubMenu}>
              <div className="menu_name cmn_name">
                <Form.Group controlId="formBasicEmail">
                  <Form.Label>Submenu Name *</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter sub menu name"
                    className="cmnfield"
                    required
                    name="nested_sub_menu_name"
                    value={this.state.nested_sub_menu_name}
                    onChange={this.handleOnchangeSubMenu}
                  />
                  <p className="text-danger">{error.nested_sub_menu_name}</p>
                </Form.Group>
              </div>
              <div className="menu_link cmn_name">
                <Form.Group controlId="formBasicEmail">
                  <Form.Label>Submenu Link *</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter sub menu url"
                    className="cmnfield"
                    required
                    name="nested_sub_menu_url"
                    value={this.state.nested_sub_menu_url}
                    onChange={this.handleOnchangeSubMenu}
                  />
                  <p className="text-danger">{error.nested_sub_menu_url}</p>
                </Form.Group>
              </div>
              <Button
                type="button"
                className="add_btnns"
                onClick={() => {
                  this.setState({
                    nested_sub_menu: [],
                    nested_sub_menu_name: "",
                    nested_sub_menu_url: "",

                    isNestedSubMenu: false,
                  });
                }}
              >
                Close
              </Button>
              <Button type="submit" className="add_btnns mx-5">
                Add Nested Sub Menu
              </Button>
            </Form>
          </Modal.Body>
        </Modal>

        <div className="right_cont">
          <div className="right_banner_banner_cnt">
            <h2>Add Menu</h2>
            <Form onSubmit={this.submitMenu}>
              <div className="menu_parttts">
                <div className="domain_name_parttssss cmn_name">
                  <Form.Label>Domain Name *</Form.Label>
                  <Form.Control
                    name="domain"
                    onChange={this.handleOnChange}
                    as="select"
                    required
                    className={`select_control ${error.domain ? "error" : ""} `}
                    value={menuData.domain}
                  >
                    <option value="">Select Domain Name</option>
                    <option value="tvi">Tipvalet Incentives</option>
                    <option value="tv">Tipvalet</option>
                  </Form.Control>
                  <p className="text-danger">{error.domain}</p>
                </div>
                <div className="menu_name cmn_name">
                  <Form.Group controlId="formBasicEmail">
                    <Form.Label>Menu Name *</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter menu name"
                      className={`cmnfield ${error.menu ? "error" : ""}`}
                      name="menu"
                      required
                      value={menuData.menu}
                      onChange={this.handleOnChange}
                    />
                    <p className="text-danger">{error.menu}</p>
                  </Form.Group>
                </div>

                <div className="d-flex">
                  <div className="menu_logo file btn btn-lg btn-primary">
                    Add Icon
                    <input
                      type="file"
                      name="icon"
                      accept="image/png"
                      onChange={this.handleImage}
                    />
                  </div>

                  {menuData.icon && (
                    <div className="logo_preview">
                      <img
                        src={URL.createObjectURL(menuData.icon)}
                        alt="Logo Preview"
                      />
                    </div>
                  )}
                </div>

                <div className="d-flex flex-wrap">
                  {menuData.sub_menu.map((menu, key) => {
                    return (
                      <div className="show_sub_menu d-flex" key={key}>
                        <p>Name :- {menu.sub_menu}</p>

                        {menu.nested_sub_menu.length === 0 ? (
                          <p>Link :- {menu.sub_url}</p>
                        ) : (
                          <>
                            {menu.nested_sub_menu.map((sub, key) => {
                              return (
                                <div key={key} className="nested_submenu">
                                  <p>Name :- {sub.nested_sub_menu_name}</p>
                                  <p>Link :- {sub.nested_sub_menu_url}</p>
                                </div>
                              );
                            })}
                          </>
                        )}

                        <span
                          className="menu_cross"
                          onClick={() => {
                            menuData.sub_menu.splice(key, 1);
                            this.setState({ menuData });
                          }}
                        >
                          X
                        </span>
                      </div>
                    );
                  })}
                </div>

                {!this.state.isAddSubMenu && (
                  <div className="add_sub_menu">
                    <button
                      type="button"
                      className="add_sub"
                      onClick={() => {
                        this.setState({ isAddSubMenu: true });
                      }}
                    >
                      <span>
                        <img src={AddLink} alt="Sub Menu" />
                      </span>
                      Add Sub Menu
                    </button>
                  </div>
                )}

                {this.state.isAddSubMenu && (
                  <div className="add_submenu_ppppaaartttsss">
                    <div className="menu_name cmn_name">
                      <Form.Group controlId="formBasicEmail">
                        <Form.Label>Submenu Name *</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter sub menu name"
                          className="cmnfield"
                          required
                          name="sub_menu_name"
                          value={this.state.sub_menu_name}
                          onChange={this.handleOnchangeSubMenu}
                        />
                        <p className="text-danger">{error.sub_menu_name}</p>
                      </Form.Group>
                    </div>

                    {/* NESTED SUB MENU */}

                    <div className="d-flex flex-wrap">
                      {nested_sub_menu.map((menu, key) => {
                        return (
                          <div className="show_sub_menu d-flex" key={key}>
                            <p>Name :- {menu.nested_sub_menu_name}</p>
                            <p>Link :- {menu.nested_sub_menu_url}</p>

                            <span
                              className="menu_cross"
                              onClick={() => {
                                nested_sub_menu.splice(key, 1);
                                this.setState({ nested_sub_menu });
                              }}
                            >
                              X
                            </span>
                          </div>
                        );
                      })}
                    </div>

                    {nested_sub_menu.length === 0 && (
                      <div className="menu_link cmn_name">
                        <Form.Group controlId="formBasicEmail">
                          <Form.Label>Submenu Link *</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter sub menu url"
                            className="cmnfield"
                            required
                            name="sub_menu_url"
                            value={this.state.sub_menu_url}
                            onChange={this.handleOnchangeSubMenu}
                          />
                          <p className="text-danger">{error.sub_menu_url}</p>
                        </Form.Group>
                      </div>
                    )}

                    <Button
                      type="button"
                      className="add_btnns"
                      onClick={this.addSubMenu}
                    >
                      Done
                    </Button>
                    <Button
                      onClick={() => {
                        this.setState({ isNestedSubMenu: true });
                      }}
                      type="button"
                      className="add_btnns mx-5"
                    >
                      Add Nested Sub Menu
                    </Button>
                  </div>
                )}

                {menuData.sub_menu.length === 0 && (
                  <div className="menu_link cmn_name">
                    <Form.Label>Menu Link</Form.Label>
                    <Form.Group controlId="formBasicEmail">
                      <Form.Control
                        type="text"
                        placeholder="Enter menu Link"
                        name="url"
                        required
                        className={`cmnfield ${error.url ? "error" : ""}`}
                        value={menuData.url}
                        onChange={this.handleOnChange}
                      />
                      <p className="text-danger">{error.url}</p>
                    </Form.Group>
                  </div>
                )}

                {/* FOR Tipvalet(tv) */}
                {menuData.domain && (
                  <div className="predecessor_menu cmn_name">
                    <Form.Label>Successor Menu</Form.Label>
                    <Form.Control
                      name="successor"
                      as="select"
                      className="select_control"
                      value={menuData.successor}
                      onChange={this.handleOnChange}
                    >
                      <option value="">Select Successor</option>

                      {menuData.domain === "tv" &&
                        tv_menu.map((menu, key) => {
                          return (
                            <option value={menu._id} key={key}>
                              {menu.menu}
                            </option>
                          );
                        })}

                      {menuData.domain === "tvi" &&
                        tvi_menu.map((menu, key) => {
                          return (
                            <option value={menu._id} key={key}>
                              {menu.menu}
                            </option>
                          );
                        })}
                    </Form.Control>
                  </div>
                )}

                <div className="add_button cmn_name">
                  <button type="submit" className="add_btnns">
                    Add
                  </button>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </LoadingOverlay>
    );
  }
}
